import { useContext, useLayoutEffect } from 'react';
import { useLocation } from 'react-router-dom';
import { PageAnimationsContext } from '../hooks/useAnimations.js';

// Tells Layout's page animations that this page's content is in the DOM. The
// layout effect runs in whichever commit puts the content in — together with
// the new URL, or a commit later after a lazy page's loading fallback — and
// after the page's own layout effects. Every route element renders inside one
// (App.jsx); Layout provides the context.
export function PageReady({ children }) {
  const { pathname } = useLocation();
  const pageAnimations = useContext(PageAnimationsContext);

  useLayoutEffect(() => {
    if (!pageAnimations) {
      throw new Error('PageReady must render inside Layout, which provides its context.');
    }
    pageAnimations.contentReady(pathname);
    return () => pageAnimations.contentGone(pathname);
  }, [pageAnimations, pathname]);

  return children;
}
